var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"div_spRelatorio"}},[_c('vue-editor',{staticStyle:{"height":"100%","overflow-y":"auto"},attrs:{"id":"editorRelat"},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }